module.exports = __webpack_public_path__ + "img/tram.6e08423a.svg";